import React, { useState, useEffect, ReactElement } from 'react';
import MUIDataTable, { MUIDataTableOptions, MUIDataTableMeta } from 'mui-datatables';

import { Grid, Snackbar, Link } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import MySnackbarContentWrapper from '../../../components/SnackBar';
import { GET_WRITERS } from '../../../queries/writer';
import PageError from '../../../components/PageError';
import PageTitle from '../../../components/PageTitle/PageTitle';
import Delete from './delete';
import ChangeStatus from './change';
import { PublishPermission } from './permissions';
import MUITableLoading from '../../../components/MUITableLoading/MUITableLoading';
import Layout from '../../../components/Layout/Layout';

export default function Writers(): ReactElement {
  const [writers, setWriters] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackType] = useState('info');
  const [snackMessage] = useState('');

  const queryWriters = useQuery(GET_WRITERS, {
    fetchPolicy: 'network-only',
  });
  const { loading, error } = queryWriters;

  useEffect(() => {
    if (queryWriters.data) {
      const { data } = queryWriters;
      setWriters(data.userListWriters);
    }
  }, [queryWriters]);

  const linkWriterName = (value: string) => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link>
        {value}
      </Link>
    );
  };

  const renderToolbarTable = (selectedRows: {
    data: {
        index: number;
        dataIndex: number;
    }[];
    lookup: {
        [key: number]: boolean;
    };
  }) => (
    <Delete selectedRows={selectedRows} writers={writers} />
  );

  const options: MUIDataTableOptions = {
    responsive: 'standard',
    customToolbarSelect: renderToolbarTable,
  };

  const handleClose = () => {
    setSnackOpen(false);
  };

  const handleChangeStatus = (tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[1];
    const status = tableMeta.rowData[3];
    return (
      <ChangeStatus id={id} status={status} />
    );
  };

  const handlePublishPermission = (tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[1];
    const canPublish = tableMeta.rowData[4];
    return (
      <PublishPermission id={id} canPublish={canPublish} />
    );
  };

  const statusWriter = (status: number) => {
    switch (status) {
      case 1:
        return 'Active';
      case 2:
        return 'Inactive';
      case 3:
        return 'Deleted';
      default:
        return '';
    }
  };

  return (
    <Layout>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={snackOpen}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackType}
          message={snackMessage}
        />
      </Snackbar>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Writers" />
        </Grid>
      </Grid>
      {
        (loading) ? <MUITableLoading columns={['NAME', 'EMAIL', 'STATUS', 'CHANGE STATUS', 'PUBLISH PERMISSION']} />
          : (error) ? <PageError />
            : (
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <MUIDataTable
                    title={false}
                    data={writers}
                    columns={[{
                      name: 'name',
                      label: 'NAME',
                      options: {
                        empty: true,
                        filter: false,
                        sort: true,
                        customBodyRender: linkWriterName,
                      },
                    },
                    {
                      name: 'id',
                      label: 'ID',
                      options: {
                        display: false,
                      },
                    },
                    {
                      name: 'email',
                      label: 'EMAIL',
                      options: {
                        display: true,
                        filter: false,
                      },
                    },
                    {
                      name: 'status',
                      label: 'STATUS',
                      options: {
                        display: true,
                        customBodyRender: (value) => {
                          return statusWriter(value);
                        },
                      },
                    },
                    {
                      name: 'canPublish',
                      label: 'Can publish',
                      options: {
                        display: false,
                      },
                    },
                    {
                      label: 'Change Status',
                      name: 'handleChangeStatus',
                      options: {
                        customBodyRender: (value, tableMeta) => {
                          return (handleChangeStatus(tableMeta));
                        },
                        empty: true,
                        filter: false,
                        sort: false,
                      },
                    },
                    {
                      label: 'Publish permission',
                      name: 'handlePublishPermission',
                      options: {
                        customBodyRender: (value, tableMeta) => {
                          return (handlePublishPermission(tableMeta));
                        },
                        empty: true,
                        filter: false,
                        sort: false,
                      },
                    },
                    ]}
                    options={options}
                  />
                </Grid>
              </Grid>
            )
      }
    </Layout>
  );
}
